export default "__VITE_ASSET__20b20326__"